import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';
import { TemplatesList } from '@client/new/pages/challenges/view/components/TemplatesList';
import { Desc } from '@client/new/pages/promotions/view/components/FormTypography';
import { Col, Row } from '@design-system/components/grid/grid';
import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import { divider, alignRight } from '../pdf/form.css';
import { useFileUploadViewModel } from '@client/new/shared/file-upload';
import { Toggle } from '@client/components/common/inputs/Toggle';
import { useState } from 'react';

export type BannerImageProps = {
  imageUrl?: string;
  onChange: (url: string) => void;
  optionality?: boolean;
  defaultState?: boolean;
};

export const BannerImage = (p: BannerImageProps) => {
  const vm = useFileUploadViewModel(p);
  const [open, setOpen] = useState(p.defaultState || false);

  return (
    <>
      <Col>
        <Row>
          <Typography variant="body" size="large" fontWeight="medium">
            Banner image
          </Typography>
          {p.optionality && (
            <Toggle value={open} onChange={() => setOpen((prev) => !prev)} />
          )}
          <SuperTooltip templateId="profile-banner" hideNavigation />
        </Row>
      </Col>
      {(!p.optionality || open) && (
        <>
          <Col>
            <Row>
              <Col>
                <Desc>
                  Upload an image. <br />
                  Minimum image dimensions: 1005 x 450
                  {vm.error && (
                    <Typography variant="body" size="small" color="ERROR-100">
                      {vm.error}
                    </Typography>
                  )}
                </Desc>
              </Col>
              <Col>
                <div className={alignRight}>
                  <Button
                    color="primary"
                    disabled={vm.isUploading}
                    variant="text"
                    size="medium"
                    onClick={() => {
                      vm.dispatch('StartBannerUpload');
                    }}
                    loading={vm.isUploading}
                  >
                    {p.imageUrl ? 'Replace' : 'Upload'}
                  </Button>
                  <input
                    type="file"
                    accept="image/jpeg,image/png"
                    ref={vm.uploadInputRef}
                    onChange={(ev) =>
                      ev.target.files?.[0] &&
                      vm.dispatch('UploadBanner', ev.target.files[0])
                    }
                    multiple={false}
                    hidden
                  />
                </div>
              </Col>
            </Row>
          </Col>
          <Row>
            <TemplatesList
              urls={[p.imageUrl || '']}
              onRemove={() => vm.dispatch('Remove')}
            />
          </Row>
        </>
      )}
    </>
  );
};
